import { render } from "./NotificationIcon.vue?vue&type=template&id=887841cc"
import script from "./NotificationIcon.vue?vue&type=script&lang=js"
export * from "./NotificationIcon.vue?vue&type=script&lang=js"

import "./NotificationIcon.vue?vue&type=style&index=0&id=887841cc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__